(() => {
  const DATA = JSON.parse(document.getElementById('scw-current-product-research')?.textContent || '{}');

  const text = (tagName, className, value) => {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    element.textContent = value;
    return element;
  };

  const panel = (container, entry) => {
    const section = document.createElement('section');
    section.className = 'scw-product-research__panel scw-product-research__panel--rookies';

    const headingId = `KeyRookies-${container.dataset.sectionId || 'theme'}-${container.dataset.productHandle}`;
    section.setAttribute('aria-labelledby', headingId);

    const heading = text('h2', 'scw-product-research__heading', 'Key Rookies');
    heading.id = headingId;
    section.appendChild(heading);

    const body = document.createElement('div');
    body.className = 'scw-product-research__body rte';
    body.id = `${headingId}-body`;
    const list = document.createElement('ul');
    entry.keyRookies.forEach((rookie, index) => {
      const item = text('li', index >= 4 ? 'scw-product-research__item--extra' : '', rookie);
      list.appendChild(item);
    });
    body.appendChild(list);
    section.appendChild(body);

    if (entry.keyRookies.length > 4) {
      const toggle = text('button', 'scw-product-research__toggle', `Show all ${entry.keyRookies.length} rookies`);
      toggle.type = 'button';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', body.id);
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        section.dataset.expanded = String(!expanded);
        toggle.textContent = expanded ? `Show all ${entry.keyRookies.length} rookies` : 'Show fewer rookies';
      });
      section.appendChild(toggle);
    }

    const note = entry.rookieNote || container.dataset.defaultDisclaimer || '';
    if (note) section.appendChild(text('p', 'scw-product-research__note', note));

    return section;
  };

  const renderContainer = (container) => {
    if (!container || container.dataset.scwHasMetafieldResearch === 'true') return;

    const handle = container.dataset.productHandle;
    const entry = DATA[handle];
    if (!entry || !Array.isArray(entry.keyRookies) || entry.keyRookies.length === 0) return;

    container.innerHTML = '';
    container.appendChild(panel(container, entry));
    container.hidden = false;
    container.dataset.scwThemeDataLoaded = 'true';
  };

  const renderAll = (root = document) => {
    root.querySelectorAll('[data-scw-product-research]').forEach(renderContainer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => renderAll());
  } else {
    renderAll();
  }

  document.addEventListener('shopify:section:load', (event) => renderAll(event.target));
})();
